import PropTypes from 'prop-types';
import React from 'react';
import ReactCollapse from 'react-collapse';

import { LocaleService } from '@sm360/widget-commons-core-services';

import AmountLineItem from 'commons-vehicle/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx';

class deliveryDetails extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showDeliveryDetails: false,
        };

        this.showDeliveryDetails = this.showDeliveryDetails.bind(this);
    }

    showDeliveryDetails() {
        this.setState((prevState) => {
            return { showDeliveryDetails: !prevState.showDeliveryDetails };
        });
    }

    render() {
        const {
            deliveryCashDown,
            deliveryFees,
            deliveryTaxes,
            deposit,
            upfrontPayment,
        } = this.props.purchaseMethodDeliveryAmounts;

        const totalDueAtDelivery = deliveryCashDown + upfrontPayment + deliveryFees + deliveryTaxes + deposit;
        return (
            <div>
                <div className="SidebarSummary__groupTitle">
                    <h3 className="sr-title SidebarSummary__groupTitle--title">
                        {LocaleService.t('SUMMARY.SIDEBAR_DELIVERY_TITLE')}
                    </h3>
                    <button className="sr-link" onClick={this.showDeliveryDetails}>
                        {!this.state.showDeliveryDetails
                            ? LocaleService.t('SUMMARY.SEE_DETAILS')
                            : LocaleService.t('SUMMARY.CLOSE_DETAILS')}
                    </button>
                </div>
                <ReactCollapse isOpened={this.state.showDeliveryDetails}>
                    <ul className="SidebarSummary__listingAmount">
                        <AmountLineItem label={LocaleService.t('SUMMARY.OTHER_FEES')} amount={deliveryFees} />
                        <AmountLineItem label={LocaleService.t('SUMMARY.CASHDOWN')} amount={deliveryCashDown} />
                        <AmountLineItem label={LocaleService.t('SUMMARY.TAXES')} amount={deliveryTaxes} />
                        <AmountLineItem label={LocaleService.t('SUMMARY.UPFRON_PAYMENT')} amount={upfrontPayment} />
                        <AmountLineItem label={LocaleService.t('SUMMARY.DEPOSIT')} amount={deposit} />
                        {totalDueAtDelivery >= 0 ? (
                            <AmountLineItem
                                label={LocaleService.t('SUMMARY.TOTAL_DUE_AT_DELIVERY')}
                                amount={totalDueAtDelivery}
                                showZero
                            />
                        ) : (
                            <AmountLineItem
                                label={LocaleService.t('SUMMARY.TOTAL_REFUND_AT_DELIVERY')}
                                amount={-1 * totalDueAtDelivery}
                            />
                        )}
                    </ul>
                </ReactCollapse>
            </div>
        );
    }
}

deliveryDetails.defaultProps = {
    purchaseMethodDeliveryAmounts: [],
};

deliveryDetails.propTypes = {
    purchaseMethodDeliveryAmounts: PropTypes.shape({
        deliveryCashDown: PropTypes.number.isRequired,
        deliveryFees: PropTypes.number.isRequired,
        deliveryTaxes: PropTypes.number.isRequired,
        deposit: PropTypes.number.isRequired,
        upfrontPayment: PropTypes.number.isRequired,
    }),
};

deliveryDetails.displayName = 'deliveryDetails';

export default deliveryDetails;



// WEBPACK FOOTER //
// ./src/Quote/components/TransactionSummary/DeliveryDetails/DeliveryDetails.jsx